// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from 'wix-data';
import wixWindow from 'wix-window';

$w.onReady(function () {

});
export function makeRepeater() {
    $w("#repeater2").forEachItem(($item, itemData, index) => {
        if (!itemData.brochure) {
            $item("#brochureButton").hide()
        }
        

    });
}
export function dataset1_ready() {
    makeRepeater()
}